<script lang="ts">
import ApocImageSet from "@/components/common/ApocImageSet.vue";
import ApocInput from "@/components/common/ApocInput.vue";
import { initStore } from "@/stores/store-manager";
import {PropType, toRef} from "vue";
import { computed, defineComponent, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

// 검색창 (검색 옵션 드롭다운 메뉴 + 입력창 + 검색 버튼)
export default defineComponent({
	name: "BannerSearch",
	components: { ApocImageSet, ApocInput },
	props: {
		onEnter: {
			type: Function as PropType<(result: string) => void>,
			required: false,
			default: () => ({}),
		},
		modelValue: {
			type: String as PropType<string>,
		},
		readOnly: {
			type: Boolean as PropType<boolean>,
			required: false,
			default: false,
		},
	},
	setup(props) {
		const { t } = useI18n({ useScope: "global" });
		const storeManager = initStore();
		const router = useRouter();
		const route = useRoute();
		const keyword = ref<string>(
			route.query.keyword ? (route.query.keyword as string) : "",
		);
		const hasInput = computed(() => keyword.value.length > 0);
    const compReadOnly = toRef(props, 'readOnly');

		// 헤더의 검색창에 입력 후 엔터 클릭 시 무조건 search 페이지로 라우트 이동
		const handleEnter = (value: string) => {
			router.push({
				path: "/search",
				query: { keyword: keyword.value, page: 1 },
			});
		};

		//모바일 검색 emit 함수
		const searchKeyword = (value: string | null) => {
			if (value) {
				router.push({
					path: "/search",
					query: { keyword: value, page: 1 },
				});
			}
		};
		watch(
			() => keyword.value,
			() => {
				storeManager.dataStore.setSearchKeyword(keyword.value);
			},
		);

		return {
			t,
      compReadOnly,
			keyword,
			hasInput,
			handleEnter,
			searchKeyword,
		};
	},
});
</script>

<template>
	<div class="banner-search-bar">
		<apoc-image-set src="/assets/images/common/icons/search.svg" />
		<apoc-input
			class="apoc-search-input"
			:placeholder="t('layout.contentBanner.placeHolder')"
			:on-enter="handleEnter"
      :read-only="compReadOnly"
			:autofocus="true"
			:model-value="keyword"
			@enter="searchKeyword"
			@update:model-value="keyword = $event" />
	</div>
</template>

<style scoped></style>
